/**
 * @description
 * Footer component for the admin dashboard layout.
 * Displays copyright information and useful links.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date 2025-01-06
 * @see admin/src/frontend/components/Layout/Footer.test.tsx
 */

/**
 * Footer component with copyright and links
 */
export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto flex flex-col items-center justify-between gap-4 py-6 px-4 max-w-7xl md:h-16 md:flex-row md:py-0">
        <div className="flex flex-col items-center gap-4 px-8 md:flex-row md:gap-2 md:px-0">
          <p className="text-center text-sm leading-loose text-muted-foreground md:text-left">
            © {currentYear} Byte Inc. All rights reserved.
          </p>
        </div>
        <div className="flex items-center gap-4">
          <a
            href="/docs"
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Documentation
          </a>
          <a
            href="/support"
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Support
          </a>
          <a
            href="/privacy"
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Privacy
          </a>
        </div>
      </div>
    </footer>
  );
}

/*
 * © 2025 Byte Inc. All rights reserved.
 * This code is the confidential and proprietary information of Byte Inc.
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Byte Inc.
 */